/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import hasFeature from './has-feature';
import hasPermission from './has-permission';
export var HAS_FEATURE_CALLBACK_NAME = 'mwfDeviceFeature.callbackFunctions.hasFeature';
export var HAS_PERMISSION_CALLBACK_NAME = 'mwfDeviceFeature.callbackFunctions.hasPermission';
window.mwfDeviceFeature = window.mwfDeviceFeature || {};
window.mwfDeviceFeature.callbackFunctions = {
  hasFeature: hasFeature,
  hasPermission: hasPermission
};
var callbackPromise = {};
export var setCallbackPromise = function setCallbackPromise(_ref) {
  var resolve = _ref.resolve,
      reject = _ref.reject,
      requestedFeature = _ref.requestedFeature;
  callbackPromise = {
    resolve: resolve,
    reject: reject,
    requestedFeature: requestedFeature
  };
};
export var getCallbackPromise = function getCallbackPromise() {
  return callbackPromise;
};